export const paddingMapping: Record<"xs" | "sm" | "md" | "lg", string> = {
  xs: "tw-p-1",
  sm: "tw-p-2",
  md: "tw-p-4",
  lg: "tw-p-6",
};

export const paddingXMapping: Record<"xs" | "sm" | "md" | "lg", string> = {
  xs: "tw-px-1",
  sm: "tw-px-2",
  md: "tw-px-4",
  lg: "tw-px-6",
};

export const paddingYMapping: Record<"xs" | "sm" | "md" | "lg", string> = {
  xs: "tw-py-1",
  sm: "tw-py-2",
  md: "tw-py-4",
  lg: "tw-py-6",
};
export const paddingTopMapping: Record<"xs" | "sm" | "md" | "lg", string> = {
  xs: "tw-pt-1",
  sm: "tw-pt-2",
  md: "tw-pt-4",
  lg: "tw-pt-6",
};

export const paddingBottomMapping: Record<"xs" | "sm" | "md" | "lg", string> = {
  xs: "tw-pb-1",
  sm: "tw-pb-2",
  md: "tw-pb-4",
  lg: "tw-pb-6",
};

export const paddingLeftMapping: Record<"xs" | "sm" | "md" | "lg", string> = {
  xs: "tw-pl-1",
  sm: "tw-pl-2",
  md: "tw-pl-4",
  lg: "tw-pl-6",
};

export const paddingRightMapping: Record<"xs" | "sm" | "md" | "lg", string> = {
  xs: "tw-pr-1",
  sm: "tw-pr-2",
  md: "tw-pr-4",
  lg: "tw-pr-6",
};

export const marginXMapping: Record<"auto" | "sm" | "md" | "lg", string> = {
  auto: "tw-mx-auto",
  sm: "tw-mx-2",
  md: "tw-mx-4",
  lg: "tw-mx-6",
};

export const marginYMapping: Record<"auto" | "sm" | "md" | "lg", string> = {
  auto: "tw-my-auto",
  sm: "tw-my-2",
  md: "tw-my-4",
  lg: "tw-my-6",
};

export const marginLeftMapping: Record<"auto" | "sm" | "md" | "lg", string> = {
  auto: "tw-ml-auto",
  sm: "tw-ml-2",
  md: "tw-ml-4",
  lg: "tw-ml-6",
};

export const marginRightMapping: Record<"auto" | "sm" | "md" | "lg", string> = {
  auto: "tw-mr-auto",
  sm: "tw-mr-2",
  md: "tw-mr-4",
  lg: "tw-mr-6",
};

export const marginTopMapping: Record<"auto" | "sm" | "md" | "lg", string> = {
  auto: "tw-mt-auto",
  sm: "tw-mt-2",
  md: "tw-mt-4",
  lg: "tw-mt-6",
};

export const marginBottomMapping: Record<"auto" | "sm" | "md" | "lg", string> = {
  auto: "tw-mb-auto",
  sm: "tw-mb-2",
  md: "tw-mb-4",
  lg: "tw-mb-6",
};

export const alignItemsMapping: Record<
  "start" | "end" | "center" | "stretch" | "baseline",
  string
> = {
  start: "tw-items-start",
  end: "tw-items-end",
  center: "tw-items-center",
  stretch: "tw-items-stretch",
  baseline: "tw-items-baseline",
};

export const justifyItemsMapping: Record<"start" | "end" | "center" | "stretch", string> = {
  start: "tw-justify-items-start",
  end: "tw-justify-items-end",
  center: "tw-justify-items-center",
  stretch: "tw-justify-items-stretch",
};

export const justifyContentMapping: Record<
  "start" | "end" | "center" | "space-between" | "space-around" | "space-evenly",
  string
> = {
  start: "tw-justify-start",
  end: "tw-justify-end",
  center: "tw-justify-center",
  "space-between": "tw-justify-between",
  "space-around": "tw-justify-around",
  "space-evenly": "tw-justify-evenly",
};

export const justifySelfMapping: Record<"start" | "end" | "center" | "stretch", string> = {
  start: "tw-justify-self-start",
  end: "tw-justify-self-end",
  center: "tw-justify-self-center",
  stretch: "tw-justify-self-stretch",
};

export const gridColsMapping: Record<number, string> = {
  1: "tw-grid-cols-1",
  2: "tw-grid-cols-2",
  3: "tw-grid-cols-3",
  4: "tw-grid-cols-4",
  5: "tw-grid-cols-5",
  6: "tw-grid-cols-6",
  7: "tw-grid-cols-7",
  8: "tw-grid-cols-8",
  9: "tw-grid-cols-9",
  10: "tw-grid-cols-10",
  11: "tw-grid-cols-11",
  12: "tw-grid-cols-12",
};

export const gridColsMappingSm: Record<number, string> = {
  1: "sm:tw-grid-cols-1",
  2: "sm:tw-grid-cols-2",
  3: "sm:tw-grid-cols-3",
  4: "sm:tw-grid-cols-4",
  5: "sm:tw-grid-cols-5",
  6: "sm:tw-grid-cols-6",
  7: "sm:tw-grid-cols-7",
  8: "sm:tw-grid-cols-8",
  9: "sm:tw-grid-cols-9",
  10: "sm:tw-grid-cols-10",
  11: "sm:tw-grid-cols-11",
  12: "sm:tw-grid-cols-12",
};

export const gridColsMappingMd: Record<number, string> = {
  1: "md:tw-grid-cols-1",
  2: "md:tw-grid-cols-2",
  3: "md:tw-grid-cols-3",
  4: "md:tw-grid-cols-4",
  5: "md:tw-grid-cols-5",
  6: "md:tw-grid-cols-6",
  7: "md:tw-grid-cols-7",
  8: "md:tw-grid-cols-8",
  9: "md:tw-grid-cols-9",
  10: "md:tw-grid-cols-10",
  11: "md:tw-grid-cols-11",
  12: "md:tw-grid-cols-12",
};

export const gridColsMappingLg: Record<number, string> = {
  1: "lg:tw-grid-cols-1",
  2: "lg:tw-grid-cols-2",
  3: "lg:tw-grid-cols-3",
  4: "lg:tw-grid-cols-4",
  5: "lg:tw-grid-cols-5",
  6: "lg:tw-grid-cols-6",
  7: "lg:tw-grid-cols-7",
  8: "lg:tw-grid-cols-8",
  9: "lg:tw-grid-cols-9",
  10: "lg:tw-grid-cols-10",
  11: "lg:tw-grid-cols-11",
  12: "lg:tw-grid-cols-12",
};

export const gridColsMappingXl: Record<number, string> = {
  1: "xl:tw-grid-cols-1",
  2: "xl:tw-grid-cols-2",
  3: "xl:tw-grid-cols-3",
  4: "xl:tw-grid-cols-4",
  5: "xl:tw-grid-cols-5",
  6: "xl:tw-grid-cols-6",
  7: "xl:tw-grid-cols-7",
  8: "xl:tw-grid-cols-8",
  9: "xl:tw-grid-cols-9",
  10: "xl:tw-grid-cols-10",
  11: "xl:tw-grid-cols-11",
  12: "xl:tw-grid-cols-12",
};

export const gridColSpanMapping: Record<"full" | number, string> = {
  full: "tw-col-span-full",
  1: "tw-col-span-1",
  2: "tw-col-span-2",
  3: "tw-col-span-3",
  4: "tw-col-span-4",
  5: "tw-col-span-5",
  6: "tw-col-span-6",
  7: "tw-col-span-7",
  8: "tw-col-span-8",
  9: "tw-col-span-9",
  10: "tw-col-span-10",
  11: "tw-col-span-11",
  12: "tw-col-span-12",
};

export const gridColSpanMappingSm: Record<"full" | number, string> = {
  full: "sm:tw-col-span-full",
  1: "sm:tw-col-span-1",
  2: "sm:tw-col-span-2",
  3: "sm:tw-col-span-3",
  4: "sm:tw-col-span-4",
  5: "sm:tw-col-span-5",
  6: "sm:tw-col-span-6",
  7: "sm:tw-col-span-7",
  8: "sm:tw-col-span-8",
  9: "sm:tw-col-span-9",
  10: "sm:tw-col-span-10",
  11: "sm:tw-col-span-11",
  12: "sm:tw-col-span-12",
};

export const gridColSpanMappingMd: Record<"full" | number, string> = {
  full: "md:tw-col-span-full",
  1: "md:tw-col-span-1",
  2: "md:tw-col-span-2",
  3: "md:tw-col-span-3",
  4: "md:tw-col-span-4",
  5: "md:tw-col-span-5",
  6: "md:tw-col-span-6",
  7: "md:tw-col-span-7",
  8: "md:tw-col-span-8",
  9: "md:tw-col-span-9",
  10: "md:tw-col-span-10",
  11: "md:tw-col-span-11",
  12: "md:tw-col-span-12",
};

export const gridColSpanMappingLg: Record<"full" | number, string> = {
  full: "lg:tw-col-span-full",
  1: "lg:tw-col-span-1",
  2: "lg:tw-col-span-2",
  3: "lg:tw-col-span-3",
  4: "lg:tw-col-span-4",
  5: "lg:tw-col-span-5",
  6: "lg:tw-col-span-6",
  7: "lg:tw-col-span-7",
  8: "lg:tw-col-span-8",
  9: "lg:tw-col-span-9",
  10: "lg:tw-col-span-10",
  11: "lg:tw-col-span-11",
  12: "lg:tw-col-span-12",
};

export const gridColSpanMappingXl: Record<"full" | number, string> = {
  full: "xl:tw-col-span-full",
  1: "xl:tw-col-span-1",
  2: "xl:tw-col-span-2",
  3: "xl:tw-col-span-3",
  4: "xl:tw-col-span-4",
  5: "xl:tw-col-span-5",
  6: "xl:tw-col-span-6",
  7: "xl:tw-col-span-7",
  8: "xl:tw-col-span-8",
  9: "xl:tw-col-span-9",
  10: "xl:tw-col-span-10",
  11: "xl:tw-col-span-11",
  12: "xl:tw-col-span-12",
};

export const gridColSpanMappingXxl: Record<"full" | number, string> = {
  full: "2xl:tw-col-span-full",
  1: "2xl:tw-col-span-1",
  2: "2xl:tw-col-span-2",
  3: "2xl:tw-col-span-3",
  4: "2xl:tw-col-span-4",
  5: "2xl:tw-col-span-5",
  6: "2xl:tw-col-span-6",
  7: "2xl:tw-col-span-7",
  8: "2xl:tw-col-span-8",
  9: "2xl:tw-col-span-9",
  10: "2xl:tw-col-span-10",
  11: "2xl:tw-col-span-11",
  12: "2xl:tw-col-span-12",
};

export const gapMapping: Record<"xs" | "sm" | "md" | "lg" | "xl", string> = {
  xs: "tw-gap-1",
  sm: "tw-gap-2",
  md: "tw-gap-4",
  lg: "tw-gap-6",
  xl: "tw-gap-8",
};

export const rowGapMapping: Record<"xs" | "sm" | "md" | "lg" | "xl", string> = {
  xs: "tw-gap-y-1",
  sm: "tw-gap-y-2",
  md: "tw-gap-y-4",
  lg: "tw-gap-y-6",
  xl: "tw-gap-y-8",
};

export const columnGapMapping: Record<"xs" | "sm" | "md" | "lg" | "xl", string> = {
  xs: "tw-gap-x-1",
  sm: "tw-gap-x-2",
  md: "tw-gap-x-4",
  lg: "tw-gap-x-6",
  xl: "tw-gap-x-8",
};

export const textSizeMapping = {
  normal: "text-normal",
  xs: "text-xs",
  sm: "text-sm",
  lg: "text-lg",
  xl: "text-xl",
  h1: "text-h1",
  h2: "text-h2",
  h3: "text-h3",
  h4: "text-h4",
  h5: "text-h5",
  h6: "text-h6",
};

export const fontWeightMapping = {
  normal: "tw-font-normal",
  bold: "tw-font-semibold",
};

type MaxWidthClassNames = {
  prose: "tw-max-w-prose";
  sm: "tw-max-w-screen-sm";
  md: "tw-max-w-screen-md";
  lg: "tw-max-w-screen-lg";
  xl: "tw-max-w-screen-xl";
  "2xl": "tw-max-w-screen-2xl";
};
export type MaxWidth = keyof MaxWidthClassNames;

export const maxWidthClassName = (maxWidth: MaxWidth): MaxWidthClassNames[typeof maxWidth] => {
  switch (maxWidth) {
    case "prose":
      return "tw-max-w-prose";
    default:
      return `tw-max-w-screen-${maxWidth}`;
  }
};

export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export const containerClassName = (v: true | Breakpoint) => {
  switch (v) {
    case "sm":
      return "sm:tw-container";
    case "md":
      return "md:tw-container";
    case "lg":
      return "lg:tw-container";
    case "xl":
      return "xl:tw-container";
    case "2xl":
      return "2xl:tw-container";
    default:
      return "tw-container";
  }
};
